import EGSM, { EGSM_ENABLED_FIELD, EGSM_SIGNALS } from './EGSM';

const buildGoogleGtagSettings = data => {
  if (!data || typeof data !== 'object') {
    return {};
  }
  // If loadGtag is undefined (not configured), return empty object
  if (data['sync-parentGTag-loadGtag'] === undefined) {
    return {};
  }

  let tagId = data['sync-parentGTag-parentTagID'];
  const loadGtag = data['sync-parentGTag-loadGtag'] === 'true';

  let loadWhenConsentDenied = true; // Default to true if not specified
  if (data['sync-parentGTag-loadWhenConsentDenied'] !== undefined) {
    // Check if the field exists
    loadWhenConsentDenied = data['sync-parentGTag-loadWhenConsentDenied'] === 'true';
  }

  const refreshOnEmptyHash = data['sync-parentGTag-refreshOnEmptyHash'] === 'true';

  let vtcEnabled = data['sync-parentGTag-vtcEnabled'] === 'true';
  let gtgEnabled = data['sync-parentGTag-gtgEnabled'] === 'true';
  let gtgScriptSource = data['sync-parentGTag-gtgScriptSource'] ?? null;

  if (gtgEnabled === false) {
    // If GTG mode is off, the script source is not used
    gtgScriptSource = null;
  }

  const egsm = {
    enabled: data[`sync-parentGTag-${EGSM_ENABLED_FIELD}`] === 'true',
  };
  EGSM_SIGNALS.forEach(({ signal, formField }) => {
    egsm[signal] = data[`sync-parentGTag-${formField}`] ?? EGSM.NOT_SET;
  });

  if (loadGtag === false) {
    // If gtag is not loaded, we should not load it when consent is denied
    loadWhenConsentDenied = false;
    // If gtag is not loaded, tagID should not be required
    tagId = '';
    // If gtag is not loaded, GTG mode and VTC/EVC support are not applicable
    gtgEnabled = false;
    gtgScriptSource = null;
    vtcEnabled = false;
    // The mapping still feeds server-side consent enrichment; only gtag emission needs our loader
    egsm.enabled = false;
  }

  return {
    googleGtagSettings: {
      tagID: tagId,
      loadGtag: loadGtag,
      refreshOnEmptyHash: refreshOnEmptyHash,
      vtcEnabled: vtcEnabled,
      gtgEnabled: gtgEnabled,
      gtgScriptSource: gtgScriptSource,
      egsm,
      consent: {
        loadWhenConsentDenied: loadWhenConsentDenied,
      },
    },
  };
};

export default buildGoogleGtagSettings;
